<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e67NaN">
</p><p class="crth" id="d7e232">Violet Path<br/>© 2012 Olivia Lodise. All rights reserved.</p>
<p class="crt" id="d7e332">No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt" id="d7e452">This is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously.</p>
<p class="crt" id="d7e572">Published in the United States by BQB Publishing<br/>(Boutique of Quality Books Publishing Company)<br/><a href="http://www.bqbpublishing.com" id="d14e66" target="_blank">www.bqbpublishing.com</a></p>
<p class="crt" id="d14e68">Printed in the United States of America</p>
<p class="crt" id="d14e70">978-1-937084-31-8 (p)<br/>978-1-937084-32-5 (e) </p>
<p class="crt" id="d14e74">Library of Congress Control Number: 2012940546</p>
<p class="crt" id="d14e76">Book design by Robin Krauss, <a href="http://www.lindendesign.biz" id="d14e78" target="_blank">www.lindendesign.biz</a><br/>Front cover illustration by Mustafa Thomas </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lodi_9781937084325_epub_c2_r1.vue?6b446d34